import { createSelector } from 'reselect'

const getLessons = createSelector(
	[state => state.libraries],
	libraries => ({
		libraryUID: libraries.current.libraryUID,
		search: libraries.find_lessons.search,
	})
)

export default getLessons
